import { type Route } from '@/routes/route';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { PageName } from '../constant';

const { Page } = lazyImport(() => import('../index'), 'Page');

export const routes: Route[] = [
  {
    name: PageName,
    path: '/account/*',
    element: <Page />,
    enable: true,
  },
];
